import { Route } from "react-router-dom"
import { routerPaths } from "../../constants/paths"
import TiresLayout from "../../layouts/TiresLayout"
import SelectVehicle from "./SelectVehicle"
import TireSize from "./SelectTireSize"
import TopTires from "./SelectTire"
import SelectShop from "./SelectShop"
import Schedule from "./SelectInstallationDateTime"
import Confirmation from "./Confirmation"
import TireDetails from "./TireDetails"
import TireOrderDetails from "./TireOrderConfirmed"
import InstallDetails from "./InstallDetails"

const Tires = ({ history }) => {
  return (
    <>
      <TiresLayout history={history}>
        <Route path={routerPaths.selectVehicle} render={(props) => <SelectVehicle {...props} />} />
        <Route path={routerPaths.tireSize} render={(props) => <TireSize {...props} />} />
        <Route path={routerPaths.selectTire} render={(props) => <TopTires {...props} />} />
        <Route path={routerPaths.tireSelectShop} render={(props) => <SelectShop {...props} />} />
        <Route path={routerPaths.tireSchedule} render={(props) => <Schedule {...props} />} />
        <Route
          path={routerPaths.tireConfirmation}
          render={(props) => <Confirmation {...props} />}
        />
        <Route path={routerPaths.tireDetails} render={(props) => <TireDetails {...props} />} />
        <Route
          exact
          path={routerPaths.tireOrderDetails}
          render={(props) => <TireOrderDetails {...props} />}
        />
        <Route
          exact
          path={routerPaths.tireInstallDetails}
          render={(props) => <InstallDetails {...props} />}
        />
      </TiresLayout>
    </>
  )
}

export default Tires
